import { ChooseSeatModal } from './ChooseSeatModal';
export default ChooseSeatModal;
